<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-5 text-center contact">
        <h4>{{ 'footer.title' | translate }}</h4>
        <p>&nbsp; &nbsp; &nbsp;{{ 'footer.subtitle' | translate }}</p>
        @for (item of items; track item) {
          <div class="footer-item">
            <fa-icon [icon]="item.icon"></fa-icon>
            <p>
              <strong>{{ 'footer.phoneLabel' | translate }}</strong
              >&nbsp;{{ item.text }}
            </p>
          </div>
        }
      </div>
      <div class="col-md-7">
        <form class="text-end">
          <div class="input-group mb-3">
            <input
              type="email"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              [placeholder]="'footer.form.emailPlaceholder' | translate"
            />
          </div>
          <div class="input-group mb-3">
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              [placeholder]="'footer.form.messagePlaceholder' | translate"
            ></textarea>
          </div>

          <button type="submit" class="btn btn-primary">
            {{ 'footer.form.submit' | translate }}
          </button>
        </form>
      </div>
      <div class="col-md-12 text-center">
        <a href="https://www.thevirtualcastle.com" target="_blank"
          ><img class="vc" src="..\assets\img\vc.png" alt=""
        /></a>
        <h6>{{ 'footer.copyright' | translate }}</h6>
        <h6>
          <a id="btn-privacy-policy" href="/privacypolicies">{{
            'footer.privacyPolicy' | translate
          }}</a>
        </h6>
        <h6>{{ 'footer.version' | translate }}: {{ version }}</h6>
      </div>
    </div>
  </div>
</footer>
